import { ETipoPoliza } from "domain/types";

const TODAS_COBERTURAS = "TodasCoberturas";

const tipoPoliza = {
  //[ETipoPoliza.TercerosCompleto]: "TERCEROS COMPLETO",
  [ETipoPoliza.TercerosCompleto]: "RESPONSIBILIDAD CIVIL",
  [ETipoPoliza.TercerosCompleto]: "INCENDIO TOTAL Y ROBO",
  [ETipoPoliza.TercerosPremium]: "TERCEROS PREMIUM",
  [ETipoPoliza.TodoRiesgo]: "TODO RIESGO",
};

const tipoPolizaFiltros = {
  [TODAS_COBERTURAS]: "Todas las coberturas",
  [ETipoPoliza.TercerosCompleto]: "Terceros completo",
  [ETipoPoliza.TercerosPremium]: "Terceros premium",
  [ETipoPoliza.TodoRiesgo]: "Todo riesgo",
  [ETipoPoliza.ResponsabilidadCivil]: "Responsabilidad civil",
};

const coberturasOrder = {
  [ETipoPoliza.TercerosCompleto]: 1,
  [ETipoPoliza.TercerosPremium]: 2,
  [ETipoPoliza.TodoRiesgo]: 3,
  [ETipoPoliza.ResponsabilidadCivil]: 4,
};

export { coberturasOrder, TODAS_COBERTURAS, tipoPoliza, tipoPolizaFiltros };
